import React from "react";
import Select from "@atlaskit/select";
import { Field, ErrorMessage } from "@atlaskit/form";
import { configTypes } from "../../../../constants/constants";

const RestoreConfigSection = (props) => {
  return (
    <>
      <Field
        aria-required={true}
        name="config"
        id="config"
        label="Configuration"
        isRequired
        isDisabled={!props.formStateData.snapshotDate}
        defaultValue={{
          value: "screens",
          label: "Screens",
        }}
        validate={async (value) => {
          if (value) {
            return undefined;
          }

          return new Promise((resolve) => setTimeout(resolve, 300)).then(
            () => "Please pick an option to configure "
          );
        }}
      >
        {({ fieldProps: { id, ...rest }, error }) => (
          <>
            <Select
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.value}
              id={`${id}-select`}
              options={configTypes}
              placeholder="Select Configuration Type"
              {...rest}
              onChange={(value) => {
                props.setFormStateData({
                  ...props.formStateData,
                  issueType: null,
                  status: null,
                  project: null,
                  configType: value,
                });
                rest.onChange({
                  label: value.label,
                  value: value.value,
                });
              }}
              validationState={!rest.isDisabled && error ? "error" : "default"}
            />
            {!rest.isDisabled && error && <ErrorMessage>{error}</ErrorMessage>}
          </>
        )}
      </Field>
    </>
  );
};

export default RestoreConfigSection;
